export {default as Footer} from './Footer'



// WEBPACK FOOTER //
// ./src/components/footer/index.js